module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_7-79886dc745400039178a01a2093f734f.jpg";